import React, { FunctionComponent, useEffect, useState, useRef } from 'react';
import { sendStepLoadedAnalyticsEvent } from '../utils';
import { getTextFactory } from 'utils/TextUtils';
import { Loading } from '@nbc-design/loading';
import { InjectedIntl } from 'react-intl';

type LoadingStatus = 'success' | undefined;
export type LoadingMessengerProps = {
  intl: InjectedIntl;
  isProfileSuccessfullyCreated: boolean;
};

const SECOND_MESSAGE_DELAY = 1500;
const SUCCESS_DELAY = 3000;

const LoadingMessenger: FunctionComponent<LoadingMessengerProps> = ({ intl, isProfileSuccessfullyCreated }) => {
  const getText = getTextFactory(intl, 'aboutYou.loading');
  const messageTimeoutRef = useRef<NodeJS.Timeout>();

  const [title, setTitle] = useState(getText('initialTitle'));
  const [textString, setTextString] = useState(getText('firstMessage'));
  const [ariaLabel, setAriaLabel] = useState('');
  const [status, setStatus] = useState<LoadingStatus>(undefined);

  // Show progressive loading message
  useEffect(() => {
    sendStepLoadedAnalyticsEvent('CREATING_PROFILE');
    messageTimeoutRef.current = setTimeout(() => {
      setTextString(getText('secondMessage'));
    }, SECOND_MESSAGE_DELAY);

    return () => {
      if (messageTimeoutRef.current) {
        clearTimeout(messageTimeoutRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Handle success state
  useEffect(() => {
    if (isProfileSuccessfullyCreated) {
      setStatus('success');
      setAriaLabel(getText('finalArial'));
      setTitle(getText('finalTitle'));
      setTextString('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isProfileSuccessfullyCreated]);

  const handleIsLoaded = () => {
    setTitle(getText('initialTitle'));
    setTextString(getText('firstMessage'));
    setStatus(undefined);
  };

  return (
    <Loading
      title={title}
      text={textString}
      ariaLabel={ariaLabel}
      status={status}
      onLoaded={handleIsLoaded}
      hideTextOnSuccess={false}
      onSuccessDelay={SUCCESS_DELAY}
    />
  );
};

export default LoadingMessenger;
